import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_time",
  "use": "icon_time-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 48 48\" id=\"icon_time\"><path fill=\"currentColor\" d=\"M24 4.5a1.5 1.5 0 000 3c9.113 0 16.5 7.387 16.5 16.5S33.113 40.5 24 40.5 7.5 33.113 7.5 24a1.5 1.5 0 00-3 0c0 10.77 8.73 19.5 19.5 19.5S43.5 34.77 43.5 24 34.77 4.5 24 4.5z\" /><path fill=\"currentColor\" d=\"M25.5 13a1.5 1.5 0 00-3 0v11.819l7.689 4.943a1.5 1.5 0 001.622-2.524L25.5 23.181V13z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol